import {Component, Inject} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';

import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

import {AlertService, AuthenticationService,} from '../../_services/index';

@Component({
    standalone: false,
    selector: 'inactivity-message-component',
    templateUrl: 'inactivity.message.component.html'
})

export class InactivityMessageComponent {

    constructor(
      public dialogRef: MatDialogRef<InactivityMessageComponent>,
      @Inject(MAT_DIALOG_DATA) public data: any,
      public router: Router,
      public route: ActivatedRoute,
      public alertService: AlertService,
      public authenticationService: AuthenticationService) {
    }

    onLogOff(): void{
        this.dialogRef.close();
        this.authenticationService.logout();
    }

    onClose(): void {
        this.dialogRef.close();
    }
}
